import * as announcementsState from './announcements';
import * as archivedRewardHistoryState from './archivedRewardHistory';
import * as archivedRewardHistoryStateV2 from './archivedRewardHistoryV2';
import * as archivedRewardHistoryStateV3 from './archivedRewardHistoryV3';
import * as articlesState from './articles';
import * as bitcoinVoucherState from './bitcoinVoucher';
import * as consumptionRewardHistoryState from './consumptionRewardHistory';
import * as depositRewardHistoryState from './depositRewardHistory';
import * as draftState from './draft';
import * as elevateTokensState from './elevateTokens';
import * as filterDataListState from './filterDataList';
import * as networkState from './network';
import * as notificationsState from './notifications';
import * as scoreTableState from './scoreTable';
import * as settingsState from './settings';
import * as topUpState from './topUp';
import * as userState from './user';
import * as withdrawalState from './withdrawal';
import * as internalTransactions from './internalTransactions';
import * as otherState from './other';

import { mergeDeepRightAll } from '~/helpers';

export default mergeDeepRightAll(
  announcementsState,
  archivedRewardHistoryState,
  archivedRewardHistoryStateV2,
  archivedRewardHistoryStateV3,
  articlesState,
  bitcoinVoucherState,
  consumptionRewardHistoryState,
  depositRewardHistoryState,
  draftState,
  elevateTokensState,
  filterDataListState,
  networkState,
  notificationsState,
  scoreTableState,
  settingsState,
  topUpState,
  userState,
  withdrawalState,
  internalTransactions,
  otherState,
);
